/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { debounceTime, map, mapTo, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { TableBlock, TextBlock } from '../../classes/Elements';
import { createBorder, createColumn, createFont, createLineHeight, createPadding } from '../../utils';
import { IpUserInterfaceService } from '../../services/internals/user-interfaces/user-interface.service';
import { IpEmailObjectStoreService } from '../../services/internals/ip-email-object-store/ip-email-object-store.service';
import { IpUserRestApiService } from '../../services/user-rest-api-service/user-rest-api.service';
import { AbstractBlock } from '../abstract-block';

@Component({
  selector: 'ip-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TableComponent extends AbstractBlock<TableBlock> implements OnInit, OnDestroy {
  // @Input() block: TextBlock;
  setAsReadOnly$ = this.internalService.currentEditingBlock$.pipe(map(editingBlock => editingBlock !== this.block));
  public staticQuillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ header: [1, 2, 3, 4, 5, 6, false] }, { size: ['small', false, 'large', 'huge'] }],
        [{ align: [] }, 'link'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        ['clean']
      ],
      handlers: {
        placeholder(selector: string) {
          const range = this.quill.getSelection();
          const format = this.quill.getFormat();
          const text = this.quill.getText(range.index, range.length);
          this.quill.deleteText(range.index, text.length);
          this.quill.insertText(range.index, selector, format);
          // this.quill.setSelection(range.index, selector.length);
        }
      }
    }
  };
  public readonly quillInit$ = this.userRestApi.getAllUserMergeFields$.pipe(
    map(placeholder => {
      // @ts-ignore
      // this.staticQuillConfig.toolbar.container.splice(-1, 0, [{ placeholder }]);
    }),
    mapTo(true),
    take(1)
  );
  private textChanged$ = new Subject();
  private componentDestroyed$ = new Subject();

  rows = [];
  columns = [];

  constructor(
    private userRestApi: IpUserRestApiService,
    private emailObject: IpEmailObjectStoreService,
    private internalService: IpUserInterfaceService
  ) {
    super();
  }

  getRowCount() {
    const { table } = this.block.options;

    const reset = table.rows != this.rows.length || table.columns != this.columns.length;

    console.log('reset == ', reset);

    if (reset) {
      if (!this.block.dataSource?.length) {
        this.block.dataSource = [];
      }
      this.rows = [];
      this.columns = [];

      for (let index = 0; index < table.rows; index++) {
        this.rows.push(index);
        if (reset && !this.block.dataSource[index]) {
          this.block.dataSource.push([]);
        }
      }

      for (let index = 0; index < table.columns; index++) {
        this.columns.push(index);
      }
    }
  }

  getColumnStyles() {
    const { border, table } = this.block.options;

    const style = {
      ...createBorder(border, 'border'),
      ...createColumn(table)
    };

    return style;
  }

  getTextStyles(index: number) {
    const { headerColor, headerFont, color, font, lineHeight } = this.block.options;

    const isHeader = index == 0;

    const useColor = isHeader ? headerColor : color;
    const useFront = isHeader ? headerFont : font;

    return {
      color:useColor,
      'word-break': 'break-all',
      ...createLineHeight(lineHeight),
      ...createFont(useFront)
    };
  }

  contentChanged() {
    this.textChanged$.next();
  }

  ngOnInit() {
    this.getRowCount();
    this.textChanged$.pipe(debounceTime(600), takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.emailObject.markForCheck();
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
